export class DrugGroup {
    id = null;
    name = null;
    code = null;
    description = null;
    drugs = null;
}